<template>
  <div>
    <TemporaryCountingTable v-show="activeKey===1" ref="list" @count="count"/>
    <TemporaryCountingDetail v-show="activeKey===2" ref="detail" :order-type="queryParam.value.business.orderType" @back="back"/>
  </div>
</template>

<script>
import TemporaryCountingTable from '@/views/counting/temporary_counting/TemporaryCountingTable.vue'
import TemporaryCountingDetail from '@/views/counting/temporary_counting/TemporaryCountingDetail.vue'

export default {
  name: 'TemporaryCounting',
  components: { TemporaryCountingTable, TemporaryCountingDetail },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    count(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row)
    }
  }
}
</script>